import { useState, useEffect } from "react";
import { Grid, Divider, Typography, FormControlLabel, Checkbox, TextField } from "@mui/material";
import Swal from "sweetalert2";

const clinicOptions = [
  { name: "generalClinic", label: "คลินิกเวชกรรม" },
  { name: "physioClinic", label: "คลินิกกายภาพบำบัด" },
  { name: "dentalClinic", label: "คลินิกทันตกรรม" },
  { name: "thaiMedClinic", label: "คลินิกการแพทย์แผนไทย" },
  { name: "specialtyClinic", label: "คลินิกเฉพาะด้าน" },
  { name: "medicalArtClinic", label: "คลินิกการประกอบโรคศิลปะ" },
  { name: "labClinic", label: "คลินิกเทคนิคการแพทย์" },
  { name: "multiClinic", label: "สหคลินิก ประกอบด้วย" },
  { name: "nurseClinic", label: "คลินิกการพยาบาลและการผดุงครรภ์" },
  { name: "pharmacy", label: "ร้านยา" },
  { name: "hospital", label: "โรงพยาบาล" },
  { name: "other", label: "อื่นๆ" },
];



interface FormDataServiceType {
  serviceType: string;
  clinicDetails: string;
  otherDetails: string;
}

interface ServiceTypeProps {
  formDataServiceType: FormDataServiceType;
  handleCheckboxServiceType: (value: string) => void;
  handleTextServiceType: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: { [key: string]: boolean };
}

const ServiceType: React.FC<ServiceTypeProps> = ({
  formDataServiceType,
  handleCheckboxServiceType,
  handleTextServiceType,
  errors,
}) => {
  
  return (
<>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
        <Grid item xs={12} md={2} sx={{ alignSelf: "flex-start", mt: 1 }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            ประเภทบริการ
          </Typography>
        </Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={1} alignItems="center">
            {clinicOptions.map((option) => (
              <Grid key={option.name} item xs={12} sm={6} sx={{ pl: 1 }}>
              <Grid container alignItems="center" sx={{ display: { xs: "block", sm: "flex" } }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formDataServiceType.serviceType === option.name}
                      onChange={() => handleCheckboxServiceType(option.name)}
                    />
                  }
                  label={option.label}
                />
                
                {(option.name === "multiClinic" || option.name === "other") && (
                  <Grid item xs={12} sm="auto">
                    <TextField
                      name={option.name === "multiClinic" ? "clinicDetails" : "otherDetails"}
                      variant="standard"
                      sx={{flex: 1 }}
                      label={<span>โปรดระบุ <span style={{ color: "red" }}>*</span></span>}
                      onChange={handleTextServiceType}
                      value={option.name === "multiClinic" ? formDataServiceType.clinicDetails : formDataServiceType.otherDetails}
                      error={!!errors[option.name === "multiClinic" ? "clinicDetails" : "otherDetails"]}
                      helperText={
                        errors[option.name === "multiClinic" ? "clinicDetails" : "otherDetails"]
                          ? "กรุณากรอกรายละเอียด"
                          : ""
                      }
                      disabled={formDataServiceType.serviceType !== option.name}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>            
            ))}
          </Grid>

          <Grid container sx={{ mt: 7 }}>
            <Grid item xs={12}>
              <Typography variant="body1">
                *หมายเหตุ : หน่วยบริการฯ สามารถสมัครเข้าร่วมตามนโยบาย “๓๐
                บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว”
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                ผ่านการสมัครโดยตรงกับสำนักงานสาธารณสุขจังหวัด เท่านั้น
                เนื่องจากต้องมีการตรวจสอบเอกสารประกอบการสมัคร
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
  </>
  );
};

export default ServiceType;
